import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_USER_REGION_LIST = {
    type: 'USER_REGION_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let callUserRegionListGet = (userId, filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    Api.get('/user-regions/' + userId + '?pg=' + pg).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_USER_REGION_LIST.payload.rows = data.rows
        ACTION_USER_REGION_LIST.payload.total = data.total
        ACTION_USER_REGION_LIST.payload.pagination = data.pagination
        dispatch(ACTION_USER_REGION_LIST)
    })
}

let callUserRegionPost = (userId, data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/user-regions/' + userId, data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

let callUserRegionDelete = (userId, id, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.delete('/user-regions/' + userId + '/' + id).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

export { callUserRegionListGet, callUserRegionPost, callUserRegionDelete, ACTION_USER_REGION_LIST }